import { useQuery, queryOptions } from '@tanstack/react-query';

import { STALE_TIMES } from '#lib/queryConstants';

import { listPipelines, listPipelineTrash } from '../../api/crmApi';

import { pipelinesKeys } from './keys';

export const pipelinesListOptions = () =>
	queryOptions({
		queryKey: pipelinesKeys.list(),
		queryFn: async () => {
			const res = await listPipelines();
			return res.pipelines ?? [];
		},
		staleTime: STALE_TIMES.STANDARD,
	});

export function usePipelines() {
	return useQuery(pipelinesListOptions());
}

export function usePipelineTrash(filters = {}, { enabled = true } = {}) {
	return useQuery({
		queryKey: pipelinesKeys.trash(filters),
		queryFn: async () => listPipelineTrash(filters),
		staleTime: STALE_TIMES.FREQUENT,
		enabled,
	});
}
